import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  purchaseOrderGridLabel: {
    defaultMessage: 'Purchase orders',
    id: 'tNpowJ',
    description: 'Purchase orders page header',
  },
  addPurchaseOrderButton: {
    defaultMessage: 'Create Purchase Order',
    id: 'H73Tlt',
    description: 'Add Purchase Order Button',
  },
  editPurchaseOrderDrawerHeaderText: {
    defaultMessage: 'Edit Purchase Order',
    id: 'yWPoe8',
    description: 'Edit purchase order drawer header text',
  },
  newPurchaseOrderDrawerHeaderText: {
    defaultMessage: 'Create Purchase Order',
    id: '9Op4G0',
    description: 'New purchase order drawer header text',
  },
  backToPurchaseOrders: {
    defaultMessage: 'Back to Purchase Orders',
    id: 'KQC+cW',
    description: 'Back to purchase orders link text',
  },
  actions: {
    defaultMessage: 'Actions',
    id: 'TTYM58',
    description: 'Actions button text',
  },
  receiveInventory: {
    defaultMessage: 'Receive Inventory',
    id: 'NHgmog',
    description: 'Receive inventory button text',
  },
  supplierCreatedSuccess: {
    defaultMessage: 'Supplier has been successfully created',
    id: 'eTCsuz',
    description: 'Supplier created success message',
  },
  supplierUpdatedSuccess: {
    defaultMessage: 'Supplier has been successfully updated',
    id: 'TdhR37',
    description: 'Supplier updated success message',
  },
  productsRequired: {
    defaultMessage: 'At least one product is required',
    id: 'g2Xrtz',
    description: 'Products required error message',
  },
  quantityMustBeGreaterThanZero: {
    defaultMessage: 'Quantity must be greater than 0',
    id: 'K/mhmU',
    description: 'Error message when product quantity is not greater than zero',
  },
  costMustBeGreaterThanOrEqualZero: {
    defaultMessage: 'Cost must be greater than or equal to 0',
    id: 'RVzDYb',
    description: 'Error message when product cost is less than zero',
  },
  quantityMustBeNumber: {
    defaultMessage: 'Quantity must be a number',
    id: '7q36dN',
    description: 'Error shown when quantity is not a valid number',
  },
  quantityRequired: {
    defaultMessage: 'Quantity is required',
    id: 'NWU0RV',
    description: 'Error shown when quantity is missing',
  },
  costMustBeNumber: {
    defaultMessage: 'Cost must be a number',
    id: 'V2Ra4E',
    description: 'Error shown when cost is not a valid number',
  },
  costRequired: {
    defaultMessage: 'Cost is required',
    id: 'HH1sL2',
    description: 'Error shown when cost is missing',
  },
  unitOfMeasureRequired: {
    defaultMessage: 'Unit of measure is required',
    id: 'icJy/a',
    description: 'Error shown when unit of measure is not selected on a product',
  },
  printPurchaseOrderButton: {
    defaultMessage: 'Print PDF',
    id: 'aGBtpt',
    description: 'Print Purchase Order Button',
  },
  receivePurchaseOrderButton: {
    id: 'QKCq34',
    defaultMessage: 'Receive',
    description: 'Button text for receiving purchase order',
  },
  receiveStock: {
    defaultMessage: 'Receive Stock',
    id: 'ZVTm81',
    description: 'Text for button to receive stock from a purchase order',
  },
  receivePurchaseOrderTitle: {
    defaultMessage: 'Receive Stock',
    id: 'Ld+TsC',
    description: 'Title of the receive purchase order drawer',
  },
  orderDate: {
    defaultMessage: 'Order Date',
    id: 'KZW5em',
    description: 'Label for purchase order order date range filter',
  },
  exportButton: {
    defaultMessage: 'Export',
    id: 'iC/ue9',
    description: 'Purchase Order Export Button',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'qz9XeG',
    description: 'Cancel button',
  },
  close: {
    defaultMessage: 'Close',
    id: 'Px7S/2',
    description: 'Close button',
  },
  purchaseOrderExportModalTitle: {
    defaultMessage: 'Purchase Order Export',
    id: 'NnS9et',
    description: 'Purchase Order Export Modal Title',
  },
  purchaseOrderExportModalStarted: {
    defaultMessage:
      'Your purchase order export has started. This may take a while so feel free to close this window. We will let you know when the export is complete.',
    id: 'PjVpbI',
    description: 'Purchase Order Export Started Message',
  },
  purchaseOrderExportSelectedItems: {
    defaultMessage: 'Only export the { selectedCount } record(s) that are currently selected',
    id: 'mDcfaF',
    description: 'Purchase Order Export Selected Items',
  },
  purchaseOrderExportAllItems: {
    defaultMessage: 'Export ALL { totalRecords } record(s) that are in view',
    id: 'vRA1RF',
    description: 'Purchase Order Export All Items',
  },
  purchaseOrderExportFailureNotificationTitle: {
    defaultMessage: 'Purchase Order Export Failed',
    id: 'PSJc6Y',
    description: 'Purchase Order Export Failure Title',
  },
  purchaseOrderExportFailureNotificationContent: {
    defaultMessage: 'An error occurred while exporting purchase orders. Please try again.',
    id: 'VdI8uZ',
    description: 'Purchase Order Export Failure Message',
  },
});
